import { isNumber } from '@art-suite/art-core-ts';

import { ApiOrgProperty, KaiProApiEndpoints } from '@kaiizen/kai-pro-api';
import { useKaiProApiClient } from '../useKaiProApiClient';

type UsePropertyStreetViewOptions = { width?: number; height?: number };

const DEFAULT_WIDTH = 320;
const DEFAULT_HEIGHT = 240;
const DEVICE_PIXEL_RATIO = typeof window !== 'undefined' ? Math.ceil(window.devicePixelRatio || 2) : 2;

const dimensionWithDefault = (input: number | undefined, defaultValue: number) => (isNumber(input) && input > 0 ? input : defaultValue) * DEVICE_PIXEL_RATIO;

export const getPropertyStreetViewUrl = (
  apiUrl: string | undefined,
  property: ApiOrgProperty,
  width?: number,
  height?: number,
) => {
  const query = new URLSearchParams({
    address: property.address,
    width: `${dimensionWithDefault(width, DEFAULT_WIDTH)}`,
    height: `${dimensionWithDefault(height, DEFAULT_HEIGHT)}`,
    fov: '70',
    pitch: '0',
  });
  const path = `${KaiProApiEndpoints.getStreetViewImage.path}?${query.toString()}`;
  return apiUrl ? new URL(path, apiUrl).toString() : path;
};

export const usePropertyStreetView = (property: ApiOrgProperty | undefined | null, { width, height }: UsePropertyStreetViewOptions = {}): string | null => {
  const kaiProApiClient = useKaiProApiClient();
  return property ? getPropertyStreetViewUrl(kaiProApiClient.options.apiUrl, property, width, height) : null;
};
